module.exports = __webpack_public_path__ + "omniv2/img/icon-seating.e33fd448.svg";